import React, { FunctionComponent } from "react"
import "./RoleAndTemplateManagementSplash.css"
import Loader from "src/components/common/Loader"


const RoleAndTemplateManagementSplash: FunctionComponent<{}> = () => {
    return (
        <div className="RoleAndTemplateManagementSplash">
            <span className="material-icons">admin_panel_settings</span>
            <Loader />
        </div>
    )
}

export default RoleAndTemplateManagementSplash